module.exports = __webpack_public_path__ + "static/media/13.9f6f12f5.JPG";